import { downloadCsv } from "../../../utils/downloadCsv";
import { encodeForCSV } from "../../../utils/csvFormatter";
import { ToastService } from "../../../utils/toastify";
import { languageService } from "../../../Language/language.service";
import { versionInfo } from "../../MainPage/VersionInfo";
import { ReportGeneratorUtils } from "../../Reports/utils/reportGeneratorUtils";

const normalize = (str) => {
  try {
    return JSON.parse(`"${str}"`);
  } catch (err) {
    return str;
  }
};
const removeExtraBS = (val) => val.replace(/\\"/g, '"');
export const MaterialUsageCSVMethod = (allExecs, mrNum, materialTypes) => {
  let materialForm = [];
  let isChargeCode = versionInfo.isChargeCodeField();
  allExecs.forEach((execution) => {
    const tasks = execution.tasks;
    tasks.forEach((t) => {
      let AfeNumber = "";

      if (t.orgMaintenances && t.orgMaintenances.length > 0) {
        AfeNumber = isChargeCode ? t.orgMaintenances[0].chargeCode : t.orgMaintenances[0].afeNumber;
        AfeNumber = encodeForCSV(AfeNumber);
      }

      t.maintenance &&
        t.maintenance.length !== 0 &&
        t.maintenance.forEach((m) => {
          let materialUseForm = m.appForms && m.appForms.find((f) => f && f.id === "sfrta_m_dailyMaterialUsageForm");

          if (!materialUseForm || !materialUseForm.form) return;
          let tableField = materialUseForm.form.find((ff) => ff && ff.id === "bloc");
          let areMatsUsed = materialUseForm.form.find((ff) => ff && ff.id === "mused");
          let showTable = areMatsUsed && areMatsUsed.value === "No" ? false : true;
          if (!showTable) return;
          if (!tableField || !tableField.value) return;
          for (let tableRow of tableField.value) {
            if (!tableRow.form) continue;
            if (tableRow.removed) continue;

            let fName = "";
            let ammount = 0;
            let unit = "";
            let item = "";
            let foundNameField = tableRow.form.find((field) => field && field.id === "mate");
            let foundAmmField = tableRow.form.find((field) => field && field.id === "amoun");
            if (!foundNameField) continue;
            let foundMType =
              materialTypes &&
              materialTypes.find(
                (mt) =>
                  normalize(mt.description) === normalize(foundNameField.value) &&
                  mt.opt1 &&
                  mt.opt1.attributes &&
                  mt.opt1.attributes.find((atr) => atr.key === "UM"),
              );

            if (foundNameField) fName = encodeForCSV(foundNameField.value);

            if (foundAmmField) ammount = foundAmmField.value;

            let UMKey =
              foundMType && foundMType.opt1 && foundMType.opt1.attributes && foundMType.opt1.attributes.find((atr) => atr.key === "UM");
            UMKey && (unit = UMKey.value);

            let ItemNum =
              foundMType &&
              foundMType.opt1 &&
              foundMType.opt1.attributes &&
              foundMType.opt1.attributes.find((atr) => atr.key === "Item No");
            let parsedVal = parseFloat(ammount);

            ItemNum && (item = encodeForCSV(ItemNum.value));
            if (isNaN(parsedVal)) parsedVal = 0;
            let rIndex = materialForm.findIndex((r) => r["Afe #"] === AfeNumber);
            rIndex = materialForm.findIndex((r) => r.Material === fName);

            //add new row
            // if (rIndex === -1)
            materialForm.push({
              "Item #": item,
              Material: removeExtraBS(fName),
              Amount: parsedVal,
              Unit: unit,
              "Afe #": AfeNumber ? AfeNumber : "",
            });
            // add value to existing row
            // else materialForm[rIndex].Amount += parsedVal;
          }
        });
    });
  });
  if (materialForm.length > 0) {
    materialForm = groupAndSum(materialForm, ["Material", "Afe #"]);
    let prepared = prepareCsvData(materialForm);
    downloadCsv(prepared, document, `MaterialUsage-${mrNum}`, "completed");
  } else {
    ToastService.Error("Error:", `${languageService("No Material Used for Work Order!")}`);
  }
};
export const ExtendedMaterialUsageCSVMethod = (allExecs, mrNum, materialTypes) => {
  let materialForm = [];
  let isChargeCode = versionInfo.isChargeCodeField();
  allExecs.forEach((execution) => {
    const tasks = execution.tasks;
    let user = "",
      date = "";
    user = (execution.user || {}).name;
    date = execution.date;
    tasks.forEach((t) => {
      let AfeNumber = "";
      let mrNumber = "",
        location = "",
        asset = "";
      if (t.orgMaintenances && t.orgMaintenances.length > 0) {
        AfeNumber = isChargeCode ? t.orgMaintenances[0].chargeCode : t.orgMaintenances[0].afeNumber;
        AfeNumber = encodeForCSV(AfeNumber);
        mrNumber = t.orgMaintenances[0].mrNumber;
        asset = ((t.orgMaintenances[0].issue || {}).unit || {}).unitId;
        location = t.orgMaintenances[0].lineName;
      }
      if (!asset) {
        asset = t.workOrders && t.workOrders[0] && t.workOrders[0].unit && t.workOrders[0].unit.unitId;
      }
      t.maintenance &&
        t.maintenance.length !== 0 &&
        t.maintenance.forEach((m) => {
          let materialUseForm = m.appForms && m.appForms.find((f) => f && f.id === "sfrta_m_dailyMaterialUsageForm");
          let summary = ReportGeneratorUtils.getMaintenanceAppForms(execution, ["sfrta_m_dailyMaterialUsageForm"]);
          let data = summary && summary[0];
          if (!materialUseForm || !materialUseForm.form) return;
          let tableField = materialUseForm.form.find((ff) => ff && ff.id === "bloc");
          let areMatsUsed = materialUseForm.form.find((ff) => ff && ff.id === "mused");
          let showTable = areMatsUsed && areMatsUsed.value === "No" ? false : true;
          if (!showTable) return;
          if (!tableField || !tableField.value) return;

          let milepostData = "";

          if (data.mpost) {
            milepostData = data.mpost;
          } else {
            if (data.mpStartMarker && data.mpEndMarker) {
              let check = data.mpStartMarker === "(N/A)" && data.mpEndMarker === "(N/A)";
              if (!check) milepostData = data.mpStartMarker + " - " + data.mpEndMarker;
            } else {
              if (data.mpStart && data.mpEnd) {
                milepostData = data.mpStart + " - " + data.mpEnd;
              } else if (data.mpStart && data.mpStart === data.mpEnd) {
                milepostData = data.mpStart;
              } else if (data.mpStart || data.mpEnd) {
                milepostData = data.mpStart ? data.mpStart : data.mpEnd;
              }
            }
          }
          for (let tableRow of tableField.value) {
            if (!tableRow.form) continue;
            if (tableRow.removed) continue;

            let fName = "";
            let ammount = 0;
            let unit = "";
            let item = "";
            let foundNameField = tableRow.form.find((field) => field && field.id === "mate");
            let foundAmmField = tableRow.form.find((field) => field && field.id === "amoun");
            if (!foundNameField) continue;
            let foundMType =
              materialTypes &&
              materialTypes.find(
                (mt) =>
                  normalize(mt.description) === normalize(foundNameField.value) &&
                  mt.opt1 &&
                  mt.opt1.attributes &&
                  mt.opt1.attributes.find((atr) => atr.key === "UM"),
              );

            if (foundNameField) fName = encodeForCSV(foundNameField.value);

            if (foundAmmField) ammount = foundAmmField.value;

            let UMKey =
              foundMType && foundMType.opt1 && foundMType.opt1.attributes && foundMType.opt1.attributes.find((atr) => atr.key === "UM");
            UMKey && (unit = UMKey.value);

            let ItemNum =
              foundMType &&
              foundMType.opt1 &&
              foundMType.opt1.attributes &&
              foundMType.opt1.attributes.find((atr) => atr.key === "Item No");
            let parsedVal = parseFloat(ammount);

            ItemNum && (item = encodeForCSV(ItemNum.value));
            if (isNaN(parsedVal)) parsedVal = 0;
            let rIndex = materialForm.findIndex((r) => r["Afe #"] === AfeNumber);
            rIndex = materialForm.findIndex((r) => r.Material === fName);

            materialForm.push({
              "Item #": item,
              Material: removeExtraBS(fName),
              Amount: parsedVal,
              Unit: unit,
              "Afe #": AfeNumber ? AfeNumber : "",
              "MR#": mrNumber || execution.title,
              Location: location || execution.lineName,
              Asset: asset,
              "Mile Post": milepostData,
              User: user,
              Date: date ? new Date(date).toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" }) : "",
            });
          }
        });
    });
  });
  if (materialForm.length > 0) {
    materialForm = groupAndSum(materialForm, ["MR#", "User", "Date", "Material"]);
    let prepared = prepareCsvData(materialForm, true);
    downloadCsv(prepared, document, `MaterialUsageByExecution-${mrNum}`, "completed");
  } else {
    ToastService.Error("Error:", `${languageService("No Material Used for Work Order!")}`);
  }
};

function groupAndSum(array, groupByFields) {
  const resultMap = new Map();
  const afeFieldName = versionInfo.isChargeCodeField() ? "Charge Code" : "Afe #";

  array.forEach((item) => {
    const key = JSON.stringify(groupByFields.map((f) => item[f]));

    if (!resultMap.has(key)) {
      // Clone full item instead of partial
      const newItem = { ...item };

      // Normalize AFE field name if needed
      if (item["Afe #"]) {
        newItem[afeFieldName] = item["Afe #"];
        if (afeFieldName !== "Afe #") {
          delete newItem["Afe #"];
        }
      }

      newItem.Amount = 0; // reset for aggregation

      resultMap.set(key, newItem);
    }

    const existing = resultMap.get(key);
    existing.Amount += item.Amount || 0;
  });

  return Array.from(resultMap.values());
}
const prepareCsvData = (data, extended) => {
  const afeFieldName = versionInfo.isChargeCodeField() ? "Charge Code" : "Afe #";
  let extraCols = ["MR#", "Location", "Asset", "Mile Post", "User", "Date"];
  const columns = [...(extended ? extraCols : []), "Item #", "Material", "Amount", "Unit", afeFieldName];

  // Helper to extract numeric part from MR#
  const getMRNumber = (val) => {
    if (!val) return 0;
    const match = val.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  };

  // Step 1: Sort by MR#
  const sorted = [...data].sort((a, b) => {
    return getMRNumber(a["MR#"]) - getMRNumber(b["MR#"]);
  });

  // Step 2: Enforce column order
  const ordered = sorted.map((row) => {
    const newRow = {};

    columns.forEach((col) => {
      if (col === "Charge Code" || col === "Afe #") {
        newRow[col] = row["Afe #"] || row["Charge Code"] || "";
      } else {
        newRow[col] = row[col] !== undefined ? row[col] : "";
      }
    });

    return newRow;
  });

  return ordered;
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetailPage/MaterialUsageCSV.js